/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// image with text Read More function

function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = "expires="+ d.toUTCString();
	var domain = location.hostname; // Get the website's domain (e.g., 'example.com')
	var path = "/"; 
	  
	document.cookie = cname + "=" + cvalue + "; " + expires + "; domain=" + domain + "; path=" + path;
} 

function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for(var i=0; i<ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1);
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		} 
	}
	return "";
}

const read_more = document.querySelectorAll('.read-more');

read_more.forEach(link => {
  link.addEventListener('click', function handleClick(event) {
    event.preventDefault();
    link.classList.add("hide")
    link.nextElementSibling.classList.add("show");
  });
});

// Launch Agency | Collection List Overlays
const showOverlay = (button) => {
  let currentText = button.closest('.list-collections__item-info');
  let currentOverlay = currentText.nextSibling;
  let openOverlays = document.querySelectorAll(`.list-collections__item-additional-info:not(.hidden-overlay)`)
  button.addEventListener('click', () => {
    currentOverlay.classList.remove('hidden-overlay');
    openOverlays.forEach(overlay => overlay.classList.add(`hidden-overlay`));
  });
};

const closeOverlay = (button) => {
  let currentOverlay = button.closest('.list-collections__item-additional-info');
  button.addEventListener('click', () => {
    currentOverlay.classList.add('hidden-overlay');
  });
};

document.querySelectorAll('[data-learn-more]').forEach(button => {
  showOverlay(button);
});

document.querySelectorAll('[data-close-overlay]').forEach(button => {
  closeOverlay(button)
});

$('a[href*="#"]').click(function() {
  if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top - 170
      }, 1000, 'swing');
      return false;
    }
  }
});

$(document).on('click', 'a[href*="?page="]', function() {
  $(window).delay(500).scrollTop(0);
});

$('.product-form__item--upload #upload').change(function(){
  $('#upload-path').html($(this).val());
});


/*== Shipping Protection ====*/

let
  shipProtectCheck = document.querySelector('#ship-protect-check'),
  sp_value = null;
  
let cartloader = document.getElementById('cart-loader');

//Prevent double protections by disabling inputs
document.addEventListener('click', function (event) {
  if (event.target.closest('.drawer__content')) {
    const clickedElement = event.target.closest('.quantity-selector__button');
    if (clickedElement) {
      miniCartElement.classList.add('updating');
    }
  }
}); 

function shipping_protection_finish(){
  cartloader.style.width = "100%";
  miniCartElement.classList.remove('updating');
  
  setTimeout(() => {
    
    fetch(`${window.themeVariables.routes.rootUrl}?section=shopify-section-mini-cart`)
    .then(res => res.text())
    .then(section => {
      const cart = document.createElement('div');
      cart.innerHTML = section;
      const updatedCart = cart.querySelector(`cart-drawer .drawer__content`);
      const currentCart = document.querySelector(`cart-drawer .drawer__content`);
      
      const updatedProtectPrice = cart.querySelector(`cart-drawer #ship-protect-price`);
      const currentProtectPrice = document.querySelector(`cart-drawer #ship-protect-price`);
      
      const updatedCheckoutButton = cart.querySelector(`cart-drawer .checkout-button`);
      const currentCheckoutButton = document.querySelector(`cart-drawer .checkout-button`);
      
      const updatedDrawerContent = cart.querySelector(`cart-drawer .drawer__content`);
      const currentDrawerContent = document.querySelector(`cart-drawer .drawer__content`);
            
      //console.log( updatedCart ); 
      if (updatedDrawerContent && currentDrawerContent) {
        currentDrawerContent.innerHTML = updatedDrawerContent.innerHTML;
        currentProtectPrice.innerHTML = updatedProtectPrice.innerHTML;
        currentCheckoutButton.innerHTML = updatedCheckoutButton.innerHTML;
        
        miniCartElement.classList.remove('updating');
        cartloader.style.display = "none";
        cartloader.style.width = "0%";
        
        setTimeout(() => {
          cartloader.style.display = "block"
        }, 1000);    
        
      }
    });
  }, 400);

  //updateFreeGift(cartContent);
  
  //updateCartDrawer(); 
  
  /*
  if ( updatedCart != '' ) {
    updateCartDrawer(); 
    updateFreeGift(updatedCart);
  }*/
}

let 
  updating_cart = false,
  sp_remove_cache = {},
  cart_total_cache = 0;
  sp_add_cache = null;
  
function shipping_protection_update(cartContent){
  //console.log('checking ship');
  cartloader = document.getElementById('cart-loader');
  cartloader.style.width = "50%";
  
  setTimeout(() => {
    //console.log( cartContent );
    
    cartContent.total_price
    updating_cart = true
    //console.log(cart);
    
    let cartAttributes = {
      attributes: {
        '_shipping_protection': '',
        '_gwp1': '',
        '_gwp2': '',
      }
    }
    
    let
      cartTotal = cartContent.total_price,
      newProtectionVariant = null;
    
    //Get cartTotal minus protections
    for (const lineItem of cartContent.items) {
      if (lineItem.handle.includes('shipping-protection')) {
        cartTotal = cartTotal - lineItem.final_price; 
      }
      //should also exclude gwp products
    }
    cartTotal = cartTotal / 10000.00;
    
    //check for new checkbox
    shipProtectCheck = document.querySelector('#ship-protect-check');
    if ( shipProtectCheck ) {
      //Auto add to cart
      if ( auto_shipping_protect == true && getCookie("shipping_protection") != 'false'  ) {
        if (!shipProtectCheck.checked) {
          shipProtectCheck.checked = true; 
        }
      } 
      
      sp_value = Math.ceil( ((cartTotal * sp_percent) + sp_base) )
      sp_value = sp_value.toString();
    
      if ( shipProtectCheck.checked ) {
        console.log('sp_value:', sp_value);
        console.log('shipProtectVariantsArray:', shipProtectVariantsArray);
        
        newProtectionVariant = shipProtectVariantsArray.find(([price]) => price === sp_value);     
        
        if (newProtectionVariant) {
          cartAttributes.attributes['_shipping_protection'] = newProtectionVariant[1];
        }
      }
    }
    
    //Single Tier GWP
    const data_gwp_settings = document.querySelector('.free-gift__wrapper');
    if (data_gwp_settings) {
      const gwp_threshold = Number(data_gwp_settings.getAttribute('threshold'));
      if (gwp_threshold) {
        const gwp_giftId = data_gwp_settings.getAttribute('giftId');
        const gwp_cartTotal = Number(data_gwp_settings.getAttribute('cartTotal'));
        //console.log('gwp_data')
        //console.log(gwp_giftId)
        //console.log(gwp_threshold)
        //console.log(gwp_cartTotal)
        
        if (gwp_threshold && gwp_cartTotal > gwp_threshold){
          cartAttributes.attributes['_gwp1'] = gwp_giftId;
        } else {
        }
      }
    } 
    
    //Multi Tier GWP
    const data_gift_settings = document.querySelector(`[data-gift-settings]`);
    if (data_gift_settings) {
      const gwp_multi = JSON.parse(data_gift_settings.innerHTML);
      
      //console.log('gwp_multi')
      //console.log(gwp_multi.cartTotal)
      //console.log(gwp_multi.threshold)
      if ( gwp_multi.threshold && gwp_multi.cartTotal > gwp_multi.threshold){
        //console.log('more than');
        cartAttributes.attributes['_gwp1'] = gwp_multi.giftId;
      } else {
        //console.log('less than');
      }
      if ( gwp_multi.thresholdTwo && gwp_multi.cartTotal > gwp_multi.thresholdTwo){
        cartAttributes.attributes['_gwp2'] = gwp_multi.giftTwoId;
      }
    }
    console.log('cartAttributes:', cartAttributes);
    
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cartAttributes),
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(cart => {
      console.log('Cart updated successfully:', cart);
      shipping_protection_finish();
      // Optionally, update the UI to reflect the change
    })
    .catch(error => {
      console.error('Error updating cart:', error);
      shipping_protection_finish();
    });      
  }, 100);
}

/*
document.addEventListener('cart:updated', function(event) {
  if ( sp_updating == false ) {
    //Don't run twice if cart updated in quick succession otherwise we get 2 protections
    sp_updating = true
	  shipping_protection_update(event.detail.cart);
  }
});*/

// Select the cart drawer contents element
const cartDrawerFooter = document.querySelector('#shopify-section-mini-cart');

function ship_protect_change(checkbox){
	// Check if the event target is the checkbox
	if (checkbox.id === 'ship-protect-check') { 
    if ( !checkbox.checked) {
      setCookie('shipping_protection', 'false', 1);
    } else {
      setCookie('shipping_protection', 'true', 1);
    }
    
    //Get current cart contents then update
    fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => {
      return response.json();
    })
    .then(cart => {
      //Update shipping protection
      shipping_protection_update(cart);
    })
    .catch(error => {});
	}
}
// Use event delegation to attach a change event listener
cartDrawerFooter.addEventListener('change', function(event) {
	ship_protect_change(event.target)	
});
